import http from '../../utils/services/http';
import { Tag } from '../../../common/tags/tagTypes';

export const createTag = async (tagName: string, userId: string, currentBoardId: string) => {
    // this is partially hardcoded for testing purposes, as we develop tags we will get correct data
    const tagData = {
        color: '#0c1750',
        creator: userId,
        rootBoardIds: [currentBoardId],
        name: tagName,
    };

    await http({
        method: 'post',
        url: 'tags',
        data: tagData,
    });
};

export const updateTag = async (tagId: string, changes: Partial<Tag>) => {
    await http({
        method: 'put',
        url: `tags/${tagId}`,
        data: { tagId, changes },
    });
};

export const getTagById = async (tagId: string) => {
    const response = await http({
        method: 'get',
        url: `tags/${tagId}`,
    });

    return response.data.tag;
};

export const fetchTagsFromDb = async (params?: { boardIds?: string[]; tagIds?: string[] | null }) => {
    const response = await http({
        method: 'get',
        url: `tags`,
        params,
    });

    return response.data.tags;
};

export const deleteTag = async (tagId: string) => {
    await http({
        method: 'delete',
        url: `tags/${tagId}`,
        data: { tagId },
    });
};
